export const DASHBOARD_DATASET_DISPLAY_NAMES = {
    datasetWithTargets: "Dataset with target",
    datasetWithoutTarget: "Dataset without target",
    enquiryToCallSaleFunnelKpis: "Enquiry → Call / Sale funnel (KPIs)",
    emotoradPerformanceDataset: "Emotorad Performance Dataset",
    emotoradDailyPerformanceDataset: "Emotorad Daily Performance Dataset",
    amaronPerformanceDataset: "Amaron Performance Dataset",
    amaronDailyPerformanceDataset: "Amaron Daily Performance Dataset",
} as const;

export const DASHBOARD_DATASET_KEYS_BY_WORKSPACE = {
    dhiraagu: ["datasetWithTargets", "datasetWithoutTarget", "enquiryToCallSaleFunnelKpis"],
    emotorad: ["emotoradPerformanceDataset", "emotoradDailyPerformanceDataset"],
    amaron: ["amaronPerformanceDataset", "amaronDailyPerformanceDataset"],
} as const;

export const DASHBOARD_DATASET_COLUMN_DISPLAY_NAMES = {
    datasetWithTargets: {
        enquiryToCallsDropOffPercent: "Enquiry -> Calls Drop-off %",
        enquiryToSalesDropOffPercent: "Enquiry -> Sales Drop-off %",
        callsToSalesDropOffPercent: "Calls -> Sales Drop-off %",
        eventContainer: "Event Container",
        enquiry: "Enquiry",
        calls: "Calls",
        sales: "Sales",
        leadCaptureBooth: "Lead Capture Booth",
        doorToDoor: ["Door To Door", "Door to Door"],
        roadshow: ["Roadshow", "Road Show"],
        referralDriveCampaign: "Referral Drive Campaign",
        dealerFootfallBooster: "Dealer Footfall Booster",
        target: "Target",
        achievement: "Achievement",
        region: "Region",
        roc: "ROC",
        atoll: "Atoll",
        disposition: "Disposition",
        productCatalogue: ["Product catalogue", "Product Catalogue"],
        status: "Status",
        leadOwner: "Lead owner",
        assignedUser: "Assigned user",
        // userDistributionScoreId: "user_distribution_score.id",
        // userDistributionScoreProductAllocationProductCatalogueId: "user_distribution_score.productAllocation.product_catalogue_id",
        ou: "OU",
        island: "Island",
        userId: "User Id",
        product: "Product",
        btlActivityTemplate: "BTL template",
        eventTemplate: "Event template",
        userTemplate: "User template",
        btlActivities: ["Btl Activities", "BTL activities (total)"],
        achievementTargetPercentage: ["Attainment %", "Achievement"],
        btlExecutorAssignmentsCount: ["Participation", "BTL activities (total)"],
        btlLinkedSalesCount: ["Productivity", "Sales"],
        avgConversionTime: ["Avg. Conversion Time", "Achievement"],
    },
    datasetWithoutTarget: {
        enquiryToCallsDropOffPercent: "Enquiry -> Calls Drop-off %",
        enquiryToSalesDropOffPercent: "Enquiry -> Sales Drop-off %",
        callsToSalesDropOffPercent: "Calls -> Sales Drop-off %",
        eventContainer: "Event Container",
        enquiry: "Enquiry",
        calls: "Calls",
        sales: "Sales",
        leadCaptureBooth: "Lead Capture Booth",
        doorToDoor: ["Door To Door", "Door to Door"],
        roadshow: ["Roadshow", "Road Show"],
        referralDriveCampaign: "Referral Drive Campaign",
        dealerFootfallBooster: "Dealer Footfall Booster",
        achievement: "Achievement",
        region: "Region",
        roc: "ROC",
        atoll: "Atoll",
        disposition: "Disposition",
        productCatalogue: ["Product catalogue", "Product Catalogue"],
        status: "Status",
        leadOwner: "Lead owner",
        assignedUser: "Assigned user",
        ou: "OU",
        island: "Island",
        userId: "User Id",
        product: "Product",
        btlActivityTemplate: "BTL template",
        eventTemplate: "Event template",
        userTemplate: "User template",
        btlActivities: "BTL activities (total)",
    },
    enquiryToCallSaleFunnelKpis: {
        enquiry: "Enquiry",
        calls: "Calls",
        sales: "Sales",
        enquiryToCallPercent: "Enquiry → Call %",
        callToSalePercent: "Call → Sale %",
        enquiryToSalePercent: "Enquiry → Sale %",
        directEnquiryToSalePercent: "Direct Enquiry → Sale %",
        region: "Region",
        roc: "ROC",
        atoll: "Atoll",
        disposition: "Disposition",
        productCatalogue: ["Product catalogue", "Product Catalogue"],
        status: "Status",
        leadOwner: "Lead owner",
        assignedUser: "Assigned user",
        ou: "OU",
        island: "Island",
        userId: "User Id",
        product: "Product",
        achievement: "Achievement",
        btlActivityTemplate: "BTL template",
        eventTemplate: "Event template",
        userTemplate: "User template",
        // btlActivities: "BTL activities (total)",
    },
    emotoradPerformanceDataset: {
        leads: "Leads",
        journeys: "Journeys",
        calls: "Calls",
        walkIns: "Walk-ins",
        testRides: "Test rides",
        sales: "Sales",
        dealershipDistanceBucket: "Dealership Distance Bucket",
        leadToCallsDropOffPercent: "Lead -> Calls Drop-off %",
        callsToWalkInsDropOffPercent: "Calls -> Walk-ins Drop-off %",
        walkInsToSalesDropOffPercent: "Walk-ins -> Sales Drop-off %",
        leadToSalesDropOffPercent: "Lead -> Sales Drop-off %",
        leadToCallsPercent: "Lead -> Calls %",
        callsToWalkInsPercent: "Calls -> Walk-ins %",
        walkInsToSalesPercent: "Walk-ins -> Sales %",
        leadToSalesPercent: "Lead -> Sales %",
        callsToSalesPercent: "Calls -> Sales %",
        walkInsToTestRidesPercent: "Walk-ins -> Test rides %",
        testRidesToSalesPercent: "Test rides -> Sales %",
        callsPerSale: "Calls per Sale",
        leadsPerSale: "Leads per Sale",
        user: "User",
        leadOwner: "Lead owner",
        status: "Status",
        disposition: "Disposition",
        productCatalogue: "Product catalogue",
        achievement: "Achievement",
        ou: "OU",
        eventTemplate: "Event template",
        userTemplate: "User template",
    },
    emotoradDailyPerformanceDataset: {
        leads: "Leads",
        calls: "Calls",
        walkIns: "Walk-ins",
        testRides: "Test rides",
        sales: "Sales",
        user: "User",
        leadOwner: "Lead owner",
        status: "Status",
        disposition: "Disposition",
        productCatalogue: "Product catalogue",
        ou: "OU",
        eventTemplate: "Event template",
        userTemplate: "User template",
    },
    amaronPerformanceDataset: {
        totalLeads: "Total Leads",
        enquiries: "Enquiries",
        calls: "Calls",
        serviceBooked: "Service Booked",
        leadToCallsDropOffPercent: "Lead -> Calls Drop-off %",
        callsToServiceBookedDropOffPercent: "Calls -> Service Booked Drop-off %",
        leadToServiceBookedDropOffPercent: "Lead -> Service Booked Drop-off %",
        leadToCallsPercent: "Lead -> Calls %",
        callsToServiceBookedPercent: "Calls -> Service Booked %",
        leadToServiceBookedPercent: "Lead -> Service Booked %",
        callsPerServiceBooking: "Calls per Service Booking",
        leadsPerServiceBooking: "Leads per Service Booking",
        enquiryToCallsDropOffPercent: "Enquiry -> Calls Drop-off %",
        enquiryToCallsPercent: "Enquiry -> Calls %",
        enquiryToServiceBookedPercent: "Enquiry -> Service Booked %",
        disposition: "Disposition",
        ou: "OU",
        leadOwner: "Lead owner",
        status: "Status",
        user: "User",
        eventTemplate: "Event template",
        userTemplate: "User template",
        carMake: "Car Make",
        carModel: "Car Model",
        fuelType: "Fuel Type",
        serviceRequested: "Service Requested",
        utmSource: "UTM Source",
        category: "Category",
    },
    amaronDailyPerformanceDataset: {
        totalLeads: "Total Leads",
        enquiries: "Enquiries",
        calls: "Calls",
        serviceBooked: "Service Booked",
        serviceStartedAt: "Service Started At",
        user: "User",
        leadOwner: "Lead owner",
        disposition: "Disposition",
        ou: "OU",
        status: "Status",
        eventTemplate: "Event template",
        userTemplate: "User template",
        carMake: "Car Make",
        carModel: "Car Model",
        fuelType: "Fuel Type",
        serviceRequested: "Service Requested",
        timeSlot: "Time Slot",
        utmSource: "UTM Source",
        category: "Category",
    },
} as const;

export type DisplayNameOrAliases = string | readonly string[];
